import { Component } from 'opus-angular-seed-core';
import template from './template.html';
@Component({
    bindings: {
        question: '=',
        form: '=',
        disabled: '<',
        haswell: '=',
        sites: '=',
        chosenFile: '=',
        chosenVideoFile: '='
    },
    template
})

export default class {
    constructor (lodash, $translate, $scope, SiteResource,
                 TokenService, ModalService, QuestionService, QUESTIONS_VIDEO_TYPE_ENUM,
                 FORMS_SITE_ACCESS_ENUM, $rootScope, CkEditorService, SiteService) {
        this.lodash = lodash;
        this.$translate = $translate;
        this.$scope = $scope;
        this.SiteResource = SiteResource;
        this.ModalService = ModalService;
        this.QuestionService = QuestionService;
        this.defaultLanguage = TokenService.getCompanyLanguage();
        this.QUESTIONS_VIDEO_TYPE_ENUM = QUESTIONS_VIDEO_TYPE_ENUM;
        this.FORMS_SITE_ACCESS_ENUM = FORMS_SITE_ACCESS_ENUM;
        this.CkEditorService = CkEditorService;
        this.SiteService = SiteService;

        $rootScope.$on('set.questionSiteIds', () => this.setQuestionSiteIds());
    }

    setQuestionSiteIds () {
        if (this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES) {
            this.form.model.questionSiteIds = [];
            return;
        }
        if (this.form.model.sites && this.form.model.sites.length) {
            this.form.model.questionSiteIds = this.form.model.sites
                .map(site => site.id)
                .filter(id => id !== null);
        }
    }

    $onInit () {
        if (!this.form.model.id) {
            this.form.model.siteAccess = this.FORMS_SITE_ACCESS_ENUM.KEYS.SPECIFIED_SITES;
            if (this.showAllSites()) {
                this.form.model.siteAccess = this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
            }
        }

        this.ckconfig = {
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline', 'Strike'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] },
                { name: 'links', items: ['Link', 'Unlink'] }
            ]
        };

        this.ckconfigForName = {
            enterMode: 2,
            toolbar: [
                { name: 'basicstyles', items: ['Bold', 'Italic', 'Underline'] },
                { name: 'paragraph', items: ['NumberedList', 'BulletedList'] }
            ]
        };

        this.maxVideoFileSizeInMB = 500;
        if (!this.form.errors.questionAnswers) {
            this.form.errors.questionAnswers = [];
        }
        this.initVideoTypeValue();
        this.setQuestionSiteIds();
    }

    showAllSites () {
        return this.SiteService.hasAccessToAllSites(this.sites)
        || this.form.model.siteAccess === this.FORMS_SITE_ACCESS_ENUM.KEYS.ALL_SITES;
    }

    setFile (file) {
        this.chosenFile = file.name;
        this.form.model.removeImage = false;
        this.form.model.imageFile = file;
    }

    isMaxVideoFileSizeExceeded (fileSize) {
        return fileSize > this.maxVideoFileSizeInMB * 1000000;
    }

    validateVideoFileSize (fileSize) {
        if (this.isMaxVideoFileSizeExceeded(fileSize)) {
            this.form.errors.videoFile = this.$translate.instant('question.Inserted video must not be larger than {fileSize}Mb', {
                fileSize: this.maxVideoFileSizeInMB
            });
            return;
        }
        delete this.form.errors.videoFile;
    }

    setVideoFile (file) {
        if (!file) {
            return;
        }

        this.validateVideoFileSize(file.size);
        this.chosenVideoFile = file.name;
        this.form.model.removeVideo = false;
        this.form.model.videoFile = file;
    }

    confirmRemoveImage () {
        const msg = this.$translate.instant('question.Remove image?');
        this.ModalService.confirm(msg, 'small').then(() => {
            this.form.model.removeImage = true;
            this.$scope.$parent.vm.save(false);
        });
    }

    confirmRemoveVideo () {
        const msg = this.$translate.instant('question.Are you sure you wish to delete the video?');
        this.ModalService.confirm(msg, 'small').then(() => {
            this.form.model.removeVideo = true;
            this.$scope.$parent.vm.save(false);
        });
    }

    initVideoTypeValue () {
        if (this.selectedVideoType) {
            return;
        }

        if (this.form.model.videoFile || (this.question && this.question.videoFilename)) {
            this.selectedVideoType = this.QUESTIONS_VIDEO_TYPE_ENUM.KEYS.FILE;
            return;
        }
        this.selectedVideoType = this.QUESTIONS_VIDEO_TYPE_ENUM.KEYS.URL;
    }

    toggleVideoType () {
        if (this.selectedVideoType === this.QUESTIONS_VIDEO_TYPE_ENUM.KEYS.FILE) {
            this.form.model.videoUrl = null;
        }
        else if (this.selectedVideoType === this.QUESTIONS_VIDEO_TYPE_ENUM.KEYS.URL) {
            this.form.model.removeVideo = true;
            this.form.model.videoFile = null;
            this.chosenVideoFile = null;
            delete this.form.errors.videoFile;
        }
    }

    removePreviewImage () {
        this.chosenFile = null;
        this.form.model.imageFile = null;
    }

    removePreviewVideo () {
        this.chosenVideoFile = null;
        this.form.model.videoFile = null;
    }
}



// WEBPACK FOOTER //
// ./src/app/components/forms/questions/actions/general/index.js